import React from 'react'
import ProspectsBase from './ProspectsBase'

class BusinessPropectsIndex extends React.Component {

  render() {
    return (
      <ProspectsBase {...this.props} user_type="b2b"/>
    )
  }
}

export default BusinessPropectsIndex



// WEBPACK FOOTER //
// ./src/js/components/BusinessProspectsIndex.js